import { useFormContext } from 'react-hook-form';
import { SimplePanel } from '~/components/common/Panel';
import { TextInput } from '~/components/ui/forms/text-input';
import { LithostratAgeFormFieldsV4 } from '~/components/upload/lithostrat-age/lithostrat-age-form-fields-v4';
import type { PaleoMapFormValues } from '~/utils/modules/paleomap-v4';

export function PaleoMapFormFields() {
  const { register } = useFormContext<PaleoMapFormValues>();

  return (
    <div className="space-y-4">
      <SimplePanel title="Panel Details">
        <TextInput {...register('description')} label="Description" />
      </SimplePanel>

      <SimplePanel title="Lithostrat Age">
        <LithostratAgeFormFieldsV4 fieldNamePrefix="age" />
      </SimplePanel>
    </div>
  );
}
